/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/
const nlMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',

  'menu.default': 'Standaard',
  'menu.analytics': 'Analyses',
  'menu.ecommerce': 'E-commerce',
  'menu.content': 'Inhoud',
  'menu.pages': 'Pagina`s',
  'menu.data-list': 'Gegevenslijst',
  'menu.thumb-list': 'Duimlijst',
  'menu.image-list': 'Afbeeldingenlijst',
  'menu.details': 'Details',
  'menu.search': 'Zoekopdracht',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.update': 'Bijwerken',
  'dashboards.save': 'Opslaan',
  'dashboards.pending-orders': 'Bestellingen in behandeling',
  'dashboards.completed-orders': 'Voltooide bestellingen',
  'dashboards.refund-requests': 'Terugbetalingsverzoeken',
  'dashboards.new-comments': 'Nieuwe reacties',
  'dashboards.sales': 'Verkoop',
  'dashboards.orders': 'Bestellingen',
  'dashboards.refunds': 'Terugbetalingen',
  'dashboards.recent-orders': 'Recente bestellingen',
  'dashboards.product-categories': 'Productcategorieën',
  'dashboards.cakes': 'Taarten',
  'dashboards.tickets': 'Kaartjes',
  'dashboards.calendar': 'Kalender',
  'dashboards.best-sellers': 'Bestsellers',
  'dashboards.per-session': 'Per sessie',
  'dashboards.profile-status': 'Profielstatus',
  'dashboards.payment-status': 'Betalingsstatus',
  'dashboards.work-progress': 'Vooruitgang van het werk',
  'dashboards.tasks-completed': 'Taken voltooid',
  'dashboards.payments-done': 'Betalingen voltooid',
  'dashboards.order-stock': 'Bestellen - Voorraad',
  'dashboards.categories': 'Categorieën',
  'dashboards.quick-post': 'Snel bericht',
  'dashboards.title': 'Titel',
  'dashboards.content': 'Inhoud',
  'dashboards.ticket-count': 'Aantal tickets',
  'dashboards.commonticketsubmission': 'Veelvoorkomende ticketinzendingen',
  'dashboards.category': 'Categorie',
  'dashboards.save-and-publish': 'Opslaan en publiceren',
  'dashboards.top-viewed-posts': 'Meest bekeken berichten',
  'dashboards.posts': 'Berichten',
  'dashboards.pending-for-publish': 'In afwachting van publicatie',
  'dashboards.users': 'Gebruikers',
  'dashboards.on-approval-process': 'Over goedkeuringsproces',
  'dashboards.alerts': 'Waarschuwingen',
  'dashboards.waiting-for-notice': 'Wachten op bericht',
  'dashboards.files': 'Bestanden',
  'dashboards.pending-for-print': 'In afwachting van afdrukken',
  'dashboards.logs': 'Logboeken',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGISCH ZIT IN DE DETAILS',
  'dashboards.yes-it-is-indeed': 'Ja, dat is het inderdaad!',
  'dashboards.advanced-search': 'Geavanceerd zoeken',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': 'Land',
  'dashboards.webVisitors': 'Websitebezoekers',
  'dashboards.avatarClicks': 'Avatar-klikken',
  'dashboards.wordCloud': 'Woordwolk',
  'dashboards.topic': 'Onderwerpen',
  'dashboards.name': 'Naam',
  'dashboards.button': 'Knop',
  'dashboards.visits': 'Bezoeken',
  'dashboards.checkAvailability': 'Controleer beschikbaarheid of tarieven',
  'dashboards.details': 'Details',
  'dashboards.roomsAvailability': 'Kamers & Beschikbaarheid',
  'dashboards.startChat': 'Start een chat',
  'dashboards.restaurantsBars': 'Restaurants & Bars',
  'dashboards.groupBooking': 'Groepsboeking',
  'dashboards.promotions': 'Promoties',
  'dashboards.weedingevents': 'Bruiloft & Evenementen',
  'dashboards.lostsomething': 'Iets kwijt',
  'dashboards.producttext': 'Producttekst',
  'dashboards.bookingroomnew': 'Kamernieuw boeken',
  'dashboards.email': 'E‑mail',
  'dashboards.phone': 'Telefoon',
  'dashboards.zipcode': 'Postcode',
  'dashboards.marketingconsent': 'Marketingtoestemming',
  'dashboards.additionalinfo': 'Extra info',
  'dashboards.viewallcontacts': 'Alle contacten weergeven',
  'dashboards.current': 'Huidig',
  'dashboards.last7days': 'Laatste 7 dagen',
  'dashboards.last30days': 'Laatste 30 dagen',
  'dashboards.thisweek': 'Deze week',
  'dashboards.thismonth': 'Deze maand',
  'dashboards.previousmonth': 'Vorige maand',
  'dashboards.yeartodate': 'Jaar tot nu toe',
  'dashboards.lastyear': 'Vorig jaar',
  'dashboards.all': 'Alles',
  'dashboards.standardOccupancy': 'Standaardbezetting',
  'dashboards.max-occupancy': 'Maximale bezetting',
  'dashboards.numberOfThisType': 'Aantal van dit type',
  'dashboards.displayOrder': 'Weergavevolgorde',
  'dashboards.provider': 'Aanbieder',
  'dashboards.edit': 'Bewerken',
  'dashboards.delete': 'Verwijderen',
  'dashboards.addImages': 'Afbeeldingen toevoegen',
  'dashboards.location_ip': 'Geschatte locatie op basis van IP‑adres',
  'dashboards.near': 'In de buurt',
  'dashboards.referral': 'Gebruiker verwezen via deze website',
  'dashboards.calling_party': 'Oproeper (initiërende partij)',
  'dashboards.called_party': 'Opgeroepen partij',
  'dashboards.lastdial': 'Laatste gesprek',
  'dashboards.imagelink': 'Afbeeldingslink',
  'dashboards.browsegallery': 'Galerij bekijken',
  'dashboards.changelog': 'Wijzigingslogboek',
  'dashboards.externalresources': 'Externe bronnen',
  'dashboards.webpage': 'Webpagina',
  'dashboards.web-pages': 'Webpagina\'s',
  'dashboards.published': 'Gepubliceerd',
  'dashboards.adddocument': 'Document toevoegen',
  'dashboards.ready-to-publish': 'Klaar om te publiceren',
  'dashboards.draft': 'Concept',
  'dashboards.order-by': 'Sorteren op',
  'dashboards.add-faq': 'FAQ toevoegen',
  'dashboards.collections': 'Collecties',
  'dashboards.items': 'Artikelen',
  'dashboards.rooms-availability': 'Kamers & Beschikbaarheid',
  'dashboards.events-wedding-venues': 'Evenementen & Trouwlocaties',
  'dashboards.long-stay-enquiry': 'Langverblijf aanvraag',
  'dashboards.reservation-confirmation-request': 'Bevestiging van reservering aanvragen',
  'dashboards.modify-cancel-booking': 'Boeking wijzigen of annuleren',
  'dashboards.left-something-behind': 'Iets achtergelaten',
  'dashboards.invoice-copy': 'Factuur / ontvangstbewijs kopie',
  'dashboards.sync': 'Synchroniseren',
  'dashboards.add-web-page': 'Webpagina toevoegen',
  'dashboards.sprint-title': 'Ontmoet Sprint, onze baanbrekende automatisering om AI‑modellen 10× sneller te trainen.',
  'dashboards.sprint-description': 'Sprint werkt naast jou—om creativiteit te ontketenen, productiviteit te ontgrendelen en de tijd die het kost om de Digitale Assistent te trainen drastisch te verminderen.',
  'dashboards.sprint-feature': 'De Sprint‑functie is ontworpen om kennis van externe bronnen te synchroniseren, wat zowel bij de initiële setup als bij voortdurende data‑updates waardevol is. Wanneer uitgevoerd op een actief systeem, past Sprint de Knowledge Hub aan op basis van jouw geconfigureerde externe bronnen, wat direct invloed kan hebben op AI‑gegenereerd gedrag en antwoorden. Voor hulp bij het instellen van Sprint kun je contact opnemen met ons ondersteuningsteam.',
  'dashboards.change-password': 'Wachtwoord wijzigen',
  'dashboards.sign-out': 'Afmelden',
  'dashboards.privacy-policy': 'Privacybeleid',
  'dashboards.help-center': 'Helpcentrum',
  'dashboards.switch-account': 'Account wisselen',
  'dashboards.business-settings': 'Bedrijfsinstellingen',
  'dashboards.notifications-allowed': 'Meldingen toegestaan',
  'dashboards.dark-theme': 'Donker thema',
  'dashboards.online': 'Online',
  'dashboards.offline': 'Offline',
  'dashboards.invoice-&-payments': 'Facturen & Betalingen',
  'dashboards.upgrade-plan': 'Plan upgraden',
  'dashboards.add-room': 'Kamer toevoegen',
  'dashboards.room-type': 'Kamertype',
  'dashboards.room-name': 'Kamersnaam',
  'dashboards.how-many-guests': 'Hoeveel gasten kunnen in deze kamer verblijven?',
  'dashboards.number-of-rooms-this-type': 'Aantal kamers (van dit type)',
  'dashboards.number-of-bedrooms': 'Aantal slaapkamers',
  'dashboards.number-of-livingrooms': 'Aantal woonkamers',
  'dashboards.minimum-adults': 'Minimum volwassenen',
  'dashboards.maximum-adults': 'Maximum volwassenen',
  'dashboards.maximum-children': 'Maximum kinderen',
  'dashboards.maximum-infants': 'Maximum zuigelingen',
  'dashboards.extra-beds-allowed': 'Extra bedden toegestaan',
  'dashboards.booking-engine-code': 'Boekingssysteem-code',
  'dashboards.room-size': 'Kamergrootte',
  'dashboards.balcony-area': 'Balkonoppervlak',
  'dashboards.unit': 'Eenheid',
  'dashboards.square-meters': 'Vierkante meters',



  'web-widget.title': 'Webwidgetmenu’s voor de websitechatbot',
  /*Home page*/
  'dashboards.quickstartwithai': 'Snelle start met AI',
  'dashboards.fastestpathtoautomation': 'Je bent op het snelste pad naar automatisering met AI‑tools',
  'dashboards.insightsthatempower': 'Inzichten die versterken',
  'dashboards.trainchatbot': 'Train chatbot',
  'dashboards.automatewithforms': 'Automatiseer met formulieren',
  'dashboards.inroomdigitalcompendium': 'Digitaal compendium in de kamer',
  'dashboards.support': 'Ondersteuning',
  'dashboards.helpcenter': 'Helpcentrum',
  'dashboards.searchfaqintegrations': 'Zoek artikelen over veelgestelde vragen, integraties en meer.',
  'dashboards.asklivechat': 'Stel een vraag aan ons team via Live Chat',
  'dashboards.inroomqrcode': 'QR‑code op de kamer om informatie over het pand en de locatie te zien',
  'dashboards.customizewebwidget': 'Pas het webwidget aan en voeg het toe aan je website met een geïntegreerde AI‑chatbot',
  'dashboards.createcustomforms': 'Maak aangepaste formulieren en ontvang meldingen wanneer een gast een formulier indient',
  'dashboards.trainchatbotproperty': 'Train de chatbot met informatie over je accommodatie zoals inchecktijd, activiteiten enzovoort',
  'dashboards.chatbotinsights': 'Zie hoe je chatbot gasten betrekt en krijg inzichten in statistieken zoals websitebezoekers, veelgestelde vragen en veel meer.',
  'dashboards.addaichatbottoyourwebsite': 'Voeg AI‑chatbot toe aan uw website',

  /* Email Stats */
  'dashboards.thread-summary-title': 'Thread-samenvattingen',
  'dashboards.thread-summary-subtitle': 'E-mailsamenvattingen gegenereerd door AI',
  'dashboards.ai-replies-title': 'AI-antwoorden',
  'dashboards.ai-replies-subtitle': 'Antwoorden gegenereerd door AI',
  'dashboards.total-thread-summary-title': 'Totaal aantal gegenereerde thread-samenvattingen',
  'dashboards.total-ai-replies-title': 'Totaal aantal gegenereerde AI-antwoorden',
  'dashboards.total-draft-copied': 'Concept gekopieerd door gebruikers',
  'dashboards.urgency': 'Urgentie',
  'dashboards.sentiment': 'Sentiment',
  'dashboards.common-email-reasons': 'Veelvoorkomende e-mailredenen',
  'dashboards.topics-in-emails': 'Onderwerpen in e-mails',
  'dashboards.email-assistant-usage': 'Gebruik AI-e-mailassistent',
  'dashboards.usage-by-email-address': 'Gebruik per e-mailadres',


  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analyses',
  'pages.title.ari': 'Beschikbaarheid en tarieven',
  'pages.title.conversations': 'Gesprekken',
  'pages.title.bookings': 'Reserveringen en boekingen',
  'pages.title.tickets': 'Leads en tickets',
  'pages.title.propinfo': 'Reacties',
  'pages.title.discounts': 'Kortingen en promoties',
  'pages.title.finance': 'Financiën',
  'pages.title.integration': 'Integratie',
  'pages.title.admin': 'Beheerder',
  'pages.add-new': 'NIEUW TOEVOEGEN',
  'pages.add-new-modal-title': 'Nieuw artikel toevoegen',
  'pages.display-options': 'Weergaveopties',
  'pages.orderby': 'Bestel per: ',
  'pages.product-name': 'Productnaam',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Say something..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  "property-info.allcustomers": 'Alle klanten',
  'property-info.external-sources': 'Exernal Sources',
  'property-info.faq': 'FAQs',
  'property-info.documents': 'Documents',
  'property-info.publish-ai': 'Publish AI',
  'property-info.pre-built-templates': 'Pre-Built Templates',
  'property-info.room-types': 'Room Types',
  'property-info.about-property': 'About Property',
  'property-info.about-properties': 'About Properties',
  'property-info.facilities-services': 'Facilities & Services',
  'property-info.property-facilities': 'Property Facilities',
  'property-info.room-amenities': 'Room Amenities',
  'property-info.property-contact': 'Property Contact',
  'property-info.property-activities': 'Property Activities',
  'property-info.property-location': 'Property Location',
  'property-info.about-rooms': 'Rooms',
  'property-info.about-sites': 'About Sites',
  'property-info.special-emergencies': 'Emergencies',
  'property-info.gallery': 'Gallery',
  'property-info.policies': 'Policies',
  'property-info.nearby': 'Nearby',
  'property-info.transport': 'Transport',
  'property-info.location': 'Location',
  'property-info.about-rhproperty': 'About Retirement Home',
  'property-info.related-topics': 'Related Topics',
  'property-info.assistant-options': 'Assistant Menu',
  'property-info.restaurant-assistant-information': 'Restaurant Information',
  'property-info.restaurant-assistant-options': 'Welcome Message',
  'property-info.channel-messages': 'Channel Messages',
  'property-info.icon.gallery': 'Icon Gallery',
  'property-info.copilot': 'Copilot',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Home Information',
  'property-info.loction': 'Locations',
  'property-info.rooms-and-images': 'Rooms & Images',
  'property-info.trainig-data': 'Training Data',
  'property-info.flows': 'Flows',
  'property-info.add-your-own': 'Add Your Own',
  'property-info-utility-miscellaneous': 'Miscellaneous',
  'property-info-utility-payment': 'Payments',
  'property-info-utility-broadband': 'Broadband',
  'property-info-utility-emergency': 'Emergency',
  'property-info-utility-mobile': 'Mobile',
  'property-info-utility-moving': 'Moving',
  'property-info.publishMonitor': 'Publiceren & Monitoren',
  'property-info.webWidget': 'Webwidget',
  'property-info.media': 'Media',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Rate Plans',
  'rate-promo.rate-plan-addons': "Add-on's",
  'rate-promo.rate-plan-promos': 'Promos',

  'title.property-information': 'Property Information',

  'property.message': 'Message',
  'property.example': 'Example',
  'property.link': 'Links',
  'property.image-carousel': 'Image Carousel',
  'property.Title': 'Title',
  'property.SubTitle': 'Sub Title',

  'property.add-invoke-api': 'Invoke API',
  'property.add-message-button': 'Add Messages',
  'property.add-img-button': 'Add Images',
  'property.add-link-button': 'Add Link',

  'property.add-herocard-button': 'Add Hero Card',
  'property.add-api-button': 'Add Buttons',


  'menu.settings': 'Instellingen',
  'menu.workflows': 'Werkstromen',
  'menu.product_services': 'Producten & Diensten',
  'menu.product_recommander': 'Productaanbeveler',
  'menu.digital_guide_book': 'Digitale Gids',
  'menu.welcome_message': 'Welkomstbericht',
  'menu.about-property': 'Over Eigendom',
  'menu.property-facilities': 'Voorzieningen Eigendom',
  'menu.room-amenities': 'Kamerfaciliteiten',
  'menu.property-contact': 'Contact Eigendom',
  'menu.about-rooms': 'Kamers',
  'menu.special-emergencies': 'Noodgevallen',
  'menu.show-filter': 'Filters tonen',
  'menu.new': 'Nieuw',
  'menu.channel': 'Kanalen',
  'menu.application': 'Applicaties',
  'menu.content-manager': 'Contentbeheer',
  'menu.events-calendar': 'Evenementenkalender',
  'menu.appearance-settings': 'Uiterlijk & Instellingen',

  'dashboards.send': 'Verzenden',
  'dashboards.hello': 'Hallo',
  'dashboards.notificationsAllowed': 'Meldingen toegestaan',
  'dashboards.allowNotifications': 'Meldingen toestaan',
  'dashboards.views': 'Weergaven',
  'dashboards.bookingURL': 'Boekings-URL',
  'dashboards.searchTags': 'Zoektags',
  'dashboards.searchCategoryTags': 'Zoekcategorie-tags',
  'dashboards.bedroom': 'Slaapkamer',
  'dashboards.addBedroom': 'Slaapkamer toevoegen',
  'dashboards.frequency': 'Frequentie',
  'dashboards.includeSubpages': 'Subpagina’s opnemen',
  'dashboards.enableFaqs': 'FAQ’s inschakelen',
  'dashboards.faqsDescription': 'Door FAQ’s in te schakelen kunt u vragen invoeren terwijl het systeem de bijbehorende antwoorden uit de inhoud van de webpagina extraheert om volledige FAQ’s te maken',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Document verwijderen',
  'dashboards.confirmDelete': 'Weet u zeker dat u wilt verwijderen?',
  'dashboards.addItem': 'Item toevoegen',
  'dashboards.addFirstWebPage': 'Voeg uw eerste webpagina toe',

  'dashboards.popular-compendium': 'Populaire compendiummenu-items',
  'dashboards.wordcloudofcompendium': 'Woordwolk van compendiummenu-items',
  'dashboards.wordcloudonthings': 'Woordwolk van vragen van websitebezoekers en menu-items',
  'dashboards.common-asked': 'Veelgestelde vragen',
  'dashboards.website-visitor-asking':
    'Dingen waar websitebezoekers naar vragen',
  'dashboards.visit-country': 'Websitebezoek per land',
  'dashboards.visit-traffic': 'Land van het websiteverkeer',
  'dashboards.rooms-product': 'Kamers & Producten',
  'dashboards.popular-room-product': 'Populaire kamers en producten',
  'dashboards.connect': 'Verbinden',

  'dashboards.messenger-stats': 'Populaire menu-items',
  'dashboards.messenger-stats-topic-view':
    'Statistieken over menu-itemweergaven',
  'dashboards.messenger-stats-visits': 'Menu-itemweergaven',
  'dashboards.opening-menu-items':
    'Aantal websitebezoekers die menu-items openen',
  'dashboards.tickets-by-category': 'Tickets per categorie',
  'dashboards.download': 'Downloaden',
  'dashboards.number-totalavatarclick': 'Totaal aantal avatarklikken',
  'dashboards.subscribe-to-reports': 'Abonneer op rapporten',
  'dashboards.clicks': 'Klikken',
  'dashboards.leads': 'Leidt',
  'dashboards.hours': 'Uur',
  'dashboards.minutes': 'Notulen',

  'dashboards.ai-chatbot': 'AI-chatbot',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'Gebruik van digitaal compendium',
  'dashboards.compendium-unique-visits': 'QR-code scans/klikken',
  'dashboards.compendium-opening-menu-items': 'Aantal bekeken menu-items',
  'dashboards.compendium-total-digital-clicks':
    'Totaal aantal menu-itemweergaven',
  'dashboards.compendium-total-qr-code': 'Totaal aantal QR-code scans/kliks',
  'dashboards.compendium-avg-menu-items': 'Gemiddeld aantal menu-itemweergaven per scan',


  'property.delete': 'Verwijderen',
  'menu.userroles': 'Gebruikers en rollen',
  'menu.members': 'Leden',
  'menu.guest-pass': 'Gastpas',
  'menu.ratebookings': 'Tarieven & Boekingen',
  'dashboards.engagement-time': 'Betrokkenheidstijd digitale assistent',
  'dashboards.conversations-minutes':
    'Totaal aantal minuten en nacht (19.00 uur tot 07.00 uur) Gespreksminuten',
  'dashboards.visitor-questions': 'Vragen van bezoekers',
  'dashboards.recent-queries': 'Recente zoekopdrachten',
  'dashboards.visitor-saying':
    'Wat uw bezoekers tegen de Digitale Assistent zeggen',
  'dashboards.contacts-prechatform-leavemessage':
    'Opgeslagen contacten van pre-chatformulier en bericht achterlaten',
  'menu.dashboards': 'Inzichten',
  'menu.ari': 'Beschikbaarheid & Tarieven',
  'menu.conversations': 'Gesprekken',
  'menu.conversations.unified-inbox': 'Uniforme inbox',
  'menu.conversations.active': 'Agent-assistentie',
  'menu.conversations.archives': 'Archief',
  'menu.conversations.missed-responses': 'Gemiste reacties',
  'menu.conversations.ticket': 'Kaartjes',
  'menu.conversations.reply-templates': 'Antwoordsjablonen',
  'menu.bookings': 'Reserveringen & Boekingen',
  'menu.tickets': 'Leads en kaartjes',
  'menu.propinfo': 'Kennis hub',
  'menu.rate-promos': 'Tarieven & Promoties',
  'menu.finance': 'Financiën',
  'menu.integration': 'Verbinden',
  'menu.admin': 'Beheer en beveiliging',
  'menu.favourites': 'Favorieten',
  'menu.recommender': 'Gespreksstromen',
  'menu.assistant-setup': 'Assistent instellen',
  'menu.admin-insights': 'Beheerdersinzichten',
  'menu.super-admin': 'Super beheerder',
  'menu.groups': 'Groepen',
  'menu.properties': 'Eigenschappen',
  'menu.service-provider': 'Dienstverleners',
  'menu.spaces': 'Spaties',
  'menu.availability': 'Beschikbaarheid',
  'menu.help': 'Help',
  'menu.myAccounts': 'Mijn accounts',

  'dashboards.space-booking': 'Reserveren van ruimte',
  'dashboards.gift-voucher': 'Cadeaubonnen',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'Van',
  'dashboards.to': 'Naar',
  'dashboards.active-groups': 'Actieve groepen',
  'dashboards.active-properties': 'Actieve eigenschappen',
  'dashboards.live-properties': 'Levende eigenschappen',
  'dashboards.properties-going': 'Eigenschappen die live gaan op datumbereik',
  'dashboards.start-date': 'Startdatum',
  'dashboards.end-date': 'Einddatum',

  'dashboards.website-visits': 'Websitebezoeken',
  'dashboards.unique-visitors': 'Unieke bezoekers',
  'dashboards.last-week': 'Vorige week',
  'dashboards.this-week': 'Deze week',
  'dashboards.this-month': 'Deze maand',
  'dashboards.previous-month': 'Vorige maand',
  'dashboards.yeartodate': 'Jaar tot nu toe',
  'dashboards.lastyear': 'Vorig jaar',
  'dashboards.last-7-days': 'Laatste 7 dagen',
  'dashboards.last-30-days': 'Laatste 30 dagen',
  'dashboards.last-60-days': 'Laatste 60 dagen',
  'dashboards.last-90-days': 'Afgelopen 90 dagen',
  'dashboards.conversion-rates': 'Conversieratio`s',
  'dashboards.digital-assistant-engagement':
    'Betrokkenheid van digitale assistenten',
  'dashboards.total-overnight-conversations':
    'Totaal- en nachtelijke gesprekken (19.00 tot 07.00 uur).',
  'dashboards.percentage-accuracy': 'Understanding Accuracy',
  'dashboards.percentage-conversion': 'Websiteverkeer naar chatconversie',
  'dashboards.percentage-avatarclick': 'Websiteverkeer naar avatarklikken',
  'dashboards.percentage-negativefeedback':
    'Negatieve feedback als percentage van Avatar-klikken',
  'dashboards.percentage-amenties': 'Voorzieningenvragen',
  'dashboards.percentage-booking': 'Boekingsvragen',
  'dashboards.percentage-webchats': 'Website-chats',
  'dashboards.percentage-facebookchat': 'Facebook-chats',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': 'Totale gesprekstijd',
  'dashboards.number-totalconversation': 'Totaal gesprekken',
  'dashboards.number-websiteconversation': 'Websitegesprekken',
  'dashboards.number-facebookconversation': 'Facebook-gesprekken',
  'dashboards.number-estimatedtimesaving': 'Geschatte tijdsbesparing',
  'dashboards.number-googlemapsconversation': 'Google Maps-gesprekken',
  'dashboards.number-whatsappconversation': 'WhatsApp-gesprekken',
  'dashboards.number-instagramconversation': 'Instagram-gesprekken',
  'dashboards.number-agentconversation': 'Agentgesprekken',
  'dashboards.number-amenityqueries': 'Voorzieningenvragen',
  'dashboards.number-bookingenquiries': 'Boekingsvragen',
  'dashboards.number-groupbookingenquiries': 'Vragen over groepsboekingen',
  'dashboards.number-eventenquiries': 'Vragen over evenementen',
  'dashboards.number-longstayenquiries': 'Vragen over lang verblijf',
  'dashboards.number-totaltickets': 'Kaartjes',
  'dashboards.number-returncustomer': 'Terugkerende klant',
  'dashboards.number-redirects': 'Website-omleidingen',
  'dashboards.number-bookingengineleads': 'Leads voor boekingsengines',
  'dashboards.number-roomnightsreferred': 'Kamernachten verwezen',
  'dashboards.number-revenuereferred': 'Inkomsten verwezen',
  'menu.bookingsmenu': 'Boekingen',
  'menu.guests': 'Gastinformatie',
  'menu.whatsnew': 'Wat is er nieuw',

  'menu.formbuilder': 'Formulierbouwer',
  'forms.forms-title': 'Formulier',
  "dashboards.trainAI": "Train AI met documenten",
  "dashboards.uploadDocuments": "Upload documenten om je AI te helpen jouw bedrijf te leren kennen en klanten te helpen zoals jij dat zou doen. Je kunt bestanden toevoegen in .doc-, .pdf- of .txt-formaat.",
  'dashboards.welcomeMessage': 'Welkomstbericht',
  'dashboards.personalizeGreeting': 'Personaliseer hoe klanten worden begroet om je merk, stijl en etiquette te weerspiegelen, zodat ze zich direct welkom voelen. Pas begroetingen aan om je merk te weerspiegelen en een warm welkom te creëren.',
  'dashboards.addRoomDetails': 'Voeg details toe over elk van je kamers zodat gasten eenvoudig alles kunnen ontdekken wat ze nodig hebben om de perfecte keuze te maken en het boekingsproces eenvoudiger en sneller te maken.',
  'dashboards.trainAIFAQs': 'Train AI met FAQ’s',
  'dashboards.manualQuestions': 'Sommige vragen kunnen niet door documenten beantwoord worden of op de website gevonden worden. Hier kun je vragen handmatig toevoegen om ervoor te zorgen dat klanten altijd de informatie hebben die ze nodig hebben binnen handbereik.',
  'dashboards.publishAI': 'Publiceer AI om de meest recente updates weer te geven',
  'dashboards.retrainAfterChanges': 'Wanneer u wijzigingen aanbrengt in de Knowledge Hub of formulieren, zorg er dan voor dat u de chatbot opnieuw traint met de bijgewerkte informatie. Door uw AI te publiceren, garandeert u dat de chatbot de meest accurate en up‑to‑date antwoorden geeft.',
  'dashboards.enhanceKnowledge': 'Verbeter AI‑kennis door niet-beantwoorde vragen bij te houden',
  'dashboards.reviewUnanswered': 'Wanneer de AI een vraag niet kan beantwoorden of slechts beperkte details biedt, vindt u die vragen hier. Bekijk ze om hiaten in uw Knowledge Hub of unieke gastvragen te identificeren.',
  'dashboards.manageMedia': 'Beheer media',
  'dashboards.mediaGallery': 'Wanneer u afbeeldingen uploadt zoals kamers, voorzieningen, logo’s of uw digitale avatar, verschijnen ze in deze galerij, waardoor u een centrale plek hebt om visuele content te beheren en ervoor te zorgen dat uw gasten zien wat uw bedrijf uniek maakt.',
  'dashboards.createForms': 'Maak formulieren eenvoudig en ontvang een melding bij elke inzending.',
  'dashboards.manageForms': 'Maak en beheer formulieren om klantinformatie te verzamelen, meldingen in te stellen en ze aan te passen voor verschillende talen.',
  'dashboards.personalizeResponse': 'Personaliseer de responsstijl en hoe het gesprek vordert',
  'dashboards.controlConversation': 'Deze geavanceerde functie geeft je de mogelijkheid om te vormen en te beheersen hoe gesprekken zich ontvouwen met je klanten via verschillende kanalen.',

  'menu.virtualfrontdesk': 'Virtuele receptie',
  'menu.guestservice': 'Gastendiensten',
  'virtual-front.common-questions': 'Veelgestelde vragen',
  'virtual-front.add-on-upsells': 'Add-ons en upsells',
  'virtual-front.service-order': 'Serviceorders',
  // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
  'virtual-front.guest-service-add-on-upsells': 'Digitaal compendium',
  'virtual-front.outbound': 'Uitgaand',
  'virtual-messenger': "Webwidgetmenu's",

  'missed-response.missed-response-title': 'Titel van antwoord gemist',

  //
  'content.allconversation': 'Alle gesprekken',
  'content.active': 'Actief',
  'content.tickets': 'Tickets',
  'content.filter': 'Filteren',
  'content.createtickets': 'Tickets aanmaken',
  'content.conversation': 'Gesprek',
  'content.knowledgesearch': 'Kennisszoektocht',
  'content.reply': 'Beantwoorden',
  'content.visitorinfo': 'Bezoekersinfo',
  'content.callinfo': 'Belinfo',
  'content.allinsights': 'Alle inzichten',
  'content.availabilityrates': 'Beschikbaarheid & tarieven',
  'content.callback': 'Terugbellen',
  'content.close': 'Sluiten',
  'content.sms': 'SMS',
  'content.timestamp': 'Tijdstempel',
  'content.topics': 'Onderwerpen',
  'content.callingparty': 'Beller',
  'content.accountdomain': 'Accountdomein',
  'content.calledparty': 'Gebelde partij',
  'content.recording': 'Opname',
  'content.phonesystemoriginationcallid': 'Oproep-ID telefoon systeem oorsprong',
  'content.phonesystemterminationcallid': 'Oproep-ID telefoon systeem beëindiging',
  'content.uniqueconversationid': 'Unieke gesprek-ID',
  'content.regenerateinsights': 'Inzichten vernieuwen',
  'content.customersentiment': 'Klantgevoel',
  'content.neutral': 'Neutraal',
  'content.customerreportedbroadbandoutage': 'Klant meldde een breedbandstoring en gaf hun klant-ID en activatiedatum van de dienst op voor hulp.',
  'content.conversationinsights': 'Gespreksinzichten',
  'content.broadbandoutage': 'Breedbandstoring',
  'content.customeridverification': 'Klanten-ID verificatie',
  'content.serviceactivationdate': 'Service activatiedatum',
  'content.followups': 'Nazorg',
  'content.actionneeded': 'Actie vereist',
  'content.uniqueConversationId': 'Unieke gesprek ID',
  'content.uniqueChatId': 'Unieke chat ID',
  'content.recording&transcript': 'Opname & Transcript',
  'content.chatinsights': 'Chatinzichten',
  'content.visitedpages': 'Bezochte pagina’s',
  'content.deviceinfo': 'Apparaatinfo',
  'content.chatstartedonthispage': 'Chat gestart op deze pagina',
  'content.prechatinfo': 'Pre‑chat info',
  'content.notes': 'Notities',
  'content.reassign': 'Toewijzen',
  'content.open': 'Openen',



  /* Missed Response */
  'feedback.missed-question': 'Gemiste vraag',
  'feedback.conversation-summary': 'Gespreksoverzicht',
  'feedback.dates-in-spanish': 'Datums moeten in het Spaans zijn',
  'feedback.resolve': 'Oplossen',
  'feedback.ignore': 'Negeren',

  //integration
  // nl-NL
  'integration.select_properties': 'Eigenschappen selecteren',
  'integration.select_properties_enabled': 'Selecteer de eigenschappen die via deze integratie zijn ingeschakeld',
  'integration.services_addons': 'Diensten & Add-ons selecteren',
  'integration.services_visible': 'Selecteer welke diensten & add-ons zichtbaar zijn op deze pagina',
  'integration.appearance': 'Weergave',
  'integration.appearance_customize': 'Kies de naam van je digitale assistent, avatar en stel je kleuren in',
  'integration.booking_calendar': 'Boekingskalender',
  'integration.booking_calendar_style': 'Kies de stijl voor de pop-up van de boekingskalender',
  'integration.nudges': 'Aansporingen',
  'integration.nudges_setup': 'Stel proactieve berichten in om websitebezoekers te betrekken',
  'integration.position': 'Positie',
  'integration.position_control': 'Beheer de positie van de chat-widget op je website',
  'integration.custom_fonts': 'Aangepaste lettertypen',
  'integration.custom_fonts_upload': 'Upload eventuele aangepaste lettertypen die je op de pagina wilt gebruiken',
  'integration.custom_css': 'Aangepaste CSS',
  'integration.custom_css_usage': 'Gebruik CSS om je Digitale Compendium aan te passen',
  'integration.location': 'Locatie',
  'integration.location_embed': 'Voeg je embed-locatie-URL toe',
  'integration.external_links': 'Externe links',
  'integration.external_links_add': 'Voeg je links toe',
  'integration.language': 'Taal',
  'integration.widget_languages': 'Selecteer de talen voor de chat-widget',
  'integration.chatbot_contact': 'Chatbot',
  'integration.chatbot_enable': 'Schakel je digitale assistent in',
  'integration.chatbot_security': 'Houd je Messenger veilig',
  'integration.chatbot_trusted_pages': 'Geef je vertrouwde pagina’s weer om de Chatbot te tonen',
  'integration.chatbot_publish': 'Publiceer je digitale assistent',
  'integration.chatbot_install': 'Kopieer de codefragment om je digitale assistent te installeren',

};
export default nlMessages;